import { Delete } from '@mui/icons-material';
import { Paper, Stack } from '@mui/material';

import { FSPrimaryButton } from '@/ui/components/button/FSPrimaryButton';
import { translate } from '@/ui/i18n';

export function SelectionToolbar({
  selectedCount,
  allSelected,
  onClickDeleteSelected,
  onClickToggleAll,
  onClickCancelSelecting,
}: {
  selectedCount: number;
  allSelected: boolean;
  onClickDeleteSelected: () => void;
  onClickToggleAll: () => void;
  onClickCancelSelecting: () => void;
}) {
  return (
    <Paper elevation={3} sx={{ px: 2, py: 1, borderRadius: 2 }}>
      <Stack sx={{ flexDirection: 'row', gap: 2, justifyContent: 'flex-end' }}>
        <FSPrimaryButton
          variant="outlined"
          color="error"
          startIcon={<Delete />}
          disabled={selectedCount === 0}
          onClick={onClickDeleteSelected}
        >
          {translate('ProjectsVenue.delete-selected', {
            count: selectedCount,
          })}
        </FSPrimaryButton>
        <FSPrimaryButton
          variant="outlined"
          color="info"
          onClick={onClickToggleAll}
        >
          {translate(
            allSelected
              ? 'ProjectsVenue.deselect-all'
              : 'ProjectsVenue.select-all',
          )}
        </FSPrimaryButton>
        <FSPrimaryButton
          variant="outlined"
          color="info"
          onClick={onClickCancelSelecting}
        >
          {translate('ProjectsVenue.cancel-select')}
        </FSPrimaryButton>
      </Stack>
    </Paper>
  );
}
